import common from "./Actions/common";

export default {
    ...common,
}